"use client";

import RelatedCard from "@/app/components/cards/relatedCard";
import SingleCard from "@/app/components/cards/singleCard";
import MapEmbedLatLong from "@/app/components/map/mapLatLang";
import MapEmbedPlaceId from "@/app/components/map/mapPlaceId";
import Navbar from "@/app/components/navbar";
import fetchFromMongoDB, { fetchAreas } from "@/utils/fetchFromMongo";
import Head from "next/head";
import Link from "next/link";
import React, { useState, useEffect } from "react";

const SingleBusiness = ({ params, areaName, serverData }) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [similarBusiness, setSimilarBusiness] = useState([]);
  let city = "";
 

  // if (data && data.state) {
  //   const res = data.state.split(",");
  //   city = res[0];
  // }

  const fetchList = async () => {
    try {
      const res = await serverData;

      if (res) {
        setData(res.singleBusiness[0]);
        setLoading(false);
      }
    } catch (error) {
      console.log(error, "error in fetching data");
      setLoading(false); 
    }
  };

  const fetchRelatedData = async () => {
    try {
      const res = await serverData.singleBusiness[0].city;

      const data = await fetchAreas(res);
      if (data) {
        setSimilarBusiness(data);
        // console.log(data, 'checking fetch area api')
        setLoading(false);
      }
    } catch (error) {
      console.log(error, "error in fetching data");
      setLoading(false); 
    }
  };

  useEffect(() => {
    fetchList();

    fetchRelatedData()
    if(similarBusiness){
      console.log(similarBusiness, "similar data check");
    }
  }, [data]);


  if (loading) {
    return <div className="w-screen h-screen flex justify-center items-center"><p>Loading...</p></div>; // Render loading state until data is fetched
  }


  return (
    <>
  
      <div className="w-screen">
        <Navbar />
        <section className="w-full md:p-0 container mx-auto">
          { data && (
            <div className="text-sm text-blue-600 mb-4 mx-auto my-4 max-w-[1032px] sm:p-4 sm:pb-0">
              <Link href="/">Gift Shops Near Me </Link> &gt;

              <Link href={`/${data.state?.toLowerCase().split(" ").join("-")}`}> <span className="capitalize"> {data.state} </span></Link> &gt;
              <Link 
                href={`/${data.state?.toLowerCase().split(" ").join("-")}/${data.city?.toLowerCase().split(" ").join("-")}`}
              > <span className="capitalize"> {data.city} </span></Link> &gt;

              {data && <span className="capitalize"> {data.name}</span>}
            </div>
          )}
          <div className="max-w-[1324px] md:pt-0 pt-10 mx-auto flex justify-center items-center pb-16 flex-col lg:pb-10">
            <div className="w-full max-w-[1032px] md:py-0 md:px-0 px-5 pb-10 md:pb-8">
              <SingleCard
                imageUrl={
                  data?.photos_sample ? data.photos_sample : "/assets/imgs/no-image.jpg"
                }
                titleUrl={data?.place_link ? data.place_link : "#"}
                title={data?.name + ", " + data?.city}
                rating={data?.rating ? data.rating : ""}
                address={data?.full_address}
                // phone={data?.phone_number}
                hours={data?.hours}
                mapUrl={data?.place_link ? data.place_link : "#"}
                reviewCount={data?.review_count}
                reviewText={data?.about?.summary}
                ratingCount={data?.rating}
                checkMap={data?.place_link ? data.place_link : "#"}
                facebook={data && data?.facebook}
                instagram={data && data?.instagram}
                twitter={data && data?.twitter}
              />

              {/* <div className="w-full shadow-md p-3 border-[1px] rounded">
                <div className="flex mx-auto justify-around w-full">
                  <a href="#services">
                    <button>Services</button>
                  </a>
                  <a href="#reviews">
                    <button>Reviews</button>
                  </a>
                  <a href="#map">
                    <button>Map</button>
                  </a>
                </div>
              </div> */}

              <div className="w-full shadow-md"></div>
            </div>

            {/* Opening hours start */}
            <div className="rounded-lg bg-white p-6 shadow-lg w-full max-w-[1032px] border-[1px]">
              <div className="mb-4 flex items-center justify-between">
                <h2 className="text-xl font-semibold">Map & Directions</h2>
                <a href={data && data?.place_link} className="text-blue-600 hover:underline">
                  Directions
                </a>
              </div>

              <div className="flex lg:flex-row flex-col">
                <div className="md:mr-6 mb-4 md:w-1/4 sm:w-full">
                  <div className="mb-6">
                    <ul className="space-y-1 text-gray-700">
                      {data?.working_hours?.map((entry, index) => (
                        <li className="flex justify-between" key={index}>
                          <span className="font-medium">{entry}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <a
                    href={` tel:${data?.phone_number}`}
                    className="flex items-center sm:mb-6 md:mb-3 justify-center rounded-lg bg-blue-600 px-4 py-2 font-semibold text-white shadow transition hover:bg-blue-700"
                  >
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 5h2a2 2 0 012 2v12a2 2 0 01-2 2H3a2 2 0 01-2-2V7a2 2 0 012-2zm10 0h2a2 2 0 012 2v6a2 2 0 01-2 2h-2a2 2 0 01-2-2V7a2 2 0 012-2zm10 0h2a2 2 0 012 2v10a2 2 0 01-2 2h-2a2 2 0 01-2-2V7a2 2 0 012-2z"
                      />
                    </svg> */}
                    {data.phone_number ? data.phone_number : "Mobile no. is not available"}
                  </a>
                </div>
                <div className="h-64 md:w-3/4 sm:w-full">
                  {data && data.latitude !== null ? (
                    <MapEmbedLatLong
                      latitude={data?.latitude}
                      longitude={data?.longitude}
                      placeId={data?.place_id}
                    />
                  ) : data & data?.place_id !== null ? (
                    <MapEmbedPlaceId placeId={data?.place_id} />
                  ) : (
                    <p>No map available</p>
                  )}
                </div>
              </div>
            </div>
            {/* Opening hours end */}

            {/* Businesses around this location */}
            <div className="max-w-[1032px] mt-7">
              <div className="text-left my-4">
                <p className="text-2xl font-bold text-gray-800 text-wrap">Gift Shops near this location</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:mx-auto">
                {similarBusiness && similarBusiness.length > 0 ? (
                  similarBusiness.map((business, index) => {
                    const listingName = business.name;
                    const slug = listingName
                    ? `${listingName 
                          .toLowerCase() 
                          .replace(/[^a-z0-9\s-]/g, "") 
                          .replace(/\s+/g, "-")
                          .replace(/-+/g, "-") 
                          .replace(/^-|-$/g, "")}-${business.unique_id}` 
                    : ""; 

                  return (
                    <>
                      <RelatedCard 
                        key={index}
                        businessUrl={`/listings/${slug}`}
                        businessName={business.name}
                        ratingCount={business.review_count}
                        rating={business.rating}
                        reviewCount={business.rating}
                        businessLocation={business.full_address}
                        businessImage={business?.photos_sample ? business.photos_sample : "/assets/imgs/no-image.jpg"}
                      />
                    </>
                  );
                })
              ) : (
                <p>no data available for listing</p>
              )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SingleBusiness;
